const PASSCODE_KEY = 'cheddar-demo.passcode';
const EMAIL_KEY = 'cheddar-demo.email';
const CUSTOMER_ID_KEY = 'cheddar-demo.customerId';

export interface DemoSession {
  passcode: string;
  email: string;
  customerId: string;
}

export function customerIdFromEmail(email: string): string {
  return `demo:${email.trim().toLowerCase()}`;
}

export function loadSession(): DemoSession | null {
  const passcode = localStorage.getItem(PASSCODE_KEY);
  const email = localStorage.getItem(EMAIL_KEY);
  const customerId = localStorage.getItem(CUSTOMER_ID_KEY);
  if (!passcode || !email || !customerId) return null;
  return { passcode, email, customerId };
}

export function saveSession(session: DemoSession): void {
  localStorage.setItem(PASSCODE_KEY, session.passcode);
  localStorage.setItem(EMAIL_KEY, session.email);
  localStorage.setItem(CUSTOMER_ID_KEY, session.customerId);
}

export function clearSession(): void {
  localStorage.removeItem(PASSCODE_KEY);
  localStorage.removeItem(EMAIL_KEY);
  localStorage.removeItem(CUSTOMER_ID_KEY);
}

export const SESSION_STORAGE_KEYS = {
  passcode: PASSCODE_KEY,
  email: EMAIL_KEY,
  customerId: CUSTOMER_ID_KEY,
} as const;
